import { hasTenantAdminAccess } from "@shared/api";
import { useUserContext } from "@shared/contexts";

// Acesso à área Admin (configuração do tenant — não é "module" no sentido do
// glossário; "Module" lá é entidade do tenant DB com Licenses associadas).
// Derivado localmente de `me.tenantAccess` (GET /v1/user/me), a única fonte de
// verdade para gating de UI do Admin — sem sondar /v1/admin/*. Contrato:
// docs/prd/admin/admin-endpoints.md §0; regras: docs/permissions.md.
//
// hasAdminAccess =
//   tenantAccess != null &&
//   (tenantRole === 'owner' || tenantRole === 'ownerViewer' ||
//    managedComplexIds.length > 0)
//
// O gate real continua no backend (EnsureTenantAdminAccess), avaliado em cada
// endpoint de /v1/admin/*; aqui é só gating de UI.
export const useAdminAccessQuery = () => {
  const { user: me } = useUserContext();

  return {
    hasAdminAccess: hasTenantAdminAccess(me?.tenantAccess),
    isCheckingAdminAccess: false,
  } as const;
};
